import Header from '@/components/molecules/Header';
import { Flex, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  headerHidden?: boolean;
}

const AppPageTemplate = ({ headerHidden = false, children }: Props) => {
  return (
    <Flex width={'100%'} direction={'column'} alignItems={'center'}>
      {!headerHidden && <Header />}

      <VStack marginTop={headerHidden ? 0 : '40px'}>{children}</VStack>
    </Flex>
  );
};

export default AppPageTemplate;
